/**
 * Подпись отчётной даты блока, ru/kz.
 *
 * Нужна там, где выдача отдаёт дату состояния (`as_of_date`,
 * `state_date`), а не готовую подпись периода: подписи периодов
 * платформа собирает сама и отдаёт строкой (US-12 FR-2), а дату
 * состояния экран обязан подписать «на такое-то число» — показатель
 * моментный, и период накопления к нему не относится (US-11 FR-7.1).
 *
 * `Intl` для этого не годится: `ru-RU` даёт «1 августа 2026 г.», а нужна
 * форма «на 1 августа 2026 года», и казахская запись у неё другая.
 */

const MONTHS_RU: readonly string[] = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
];

const MONTHS_KZ: readonly string[] = [
  'қаңтардағы',
  'ақпандағы',
  'наурыздағы',
  'сәуірдегі',
  'мамырдағы',
  'маусымдағы',
  'шілдедегі',
  'тамыздағы',
  'қыркүйектегі',
  'қазандағы',
  'қарашадағы',
  'желтоқсандағы',
];

/**
 * ISO-дата (`2026-08-01`) → «на 1 августа 2026 года» /
 * «2026 жылғы 1 тамыздағы жағдай бойынша».
 *
 * Мусор и пустая строка → `null`: подпись без даты не рисуется вовсе,
 * «на —» читалось бы как отсутствующая дата у существующих данных.
 */
export const stateDateLabel = (
  iso: string | null | undefined,
  isKz: boolean,
): string | null => {
  if (iso == null || iso === '') return null;
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (match === null) return null;
  const [, year, month, day] = match;
  const index = Number.parseInt(month, 10) - 1;
  if (index < 0 || index > 11) return null;
  const dayNum = Number.parseInt(day, 10);
  return isKz
    ? `${year} жылғы ${dayNum} ${MONTHS_KZ[index]} жағдай бойынша`
    : `на ${dayNum} ${MONTHS_RU[index]} ${year} года`;
};
